import styled from "styled-components";
import { modeStyle, themeStyle } from "utils/styles";

export const Tab = styled.li`
  flex: 1;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.3s linear;

  &:hover {
    background-color: ${modeStyle("#f8f8f8", "#535353")};
  }

  > *:first-child {
    padding: 0.5rem 1rem;
  }

  a {
    display: block;
    font-family: ${themeStyle("typography.sansFamily")};
    color: inherit;
    text-decoration: none;
  }

  svg {
    vertical-align: middle;
  }
`;

export const TabBar = styled.ul`
  flex: none;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 0;
  padding: 0;
  width: 100%;
  list-style: none;
  border-bottom: 1px solid ${modeStyle("#dcdcdc", "#5d5d5d")};

  &::after {
    content: "";
    background: ${({ theme }) =>
      theme.darkMode ? "white" : theme.colors.primary};
    height: 3px;
    ${({ tabCount, activeTabIndex }) => `
      width: ${(1 / tabCount) * 100}%;
      transform: translateX(${activeTabIndex * 100}%);
    `};
    position: absolute;
    bottom: 0;
    transition: all 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
  }
`;

export const TabContents = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  align-items: flex-start;
  flex: auto;
`;

export const TabContent = styled.div`
  width: 100%;
  flex-shrink: 0;
  transition: all 200ms ease;
`;
